import React from 'react';
import SEO from '../components/SEO';
import galleryData from '../data/gallery.json';

const Gallery = () => {
  const { images } = galleryData;

  return (
    <div className="pt-20">
      <SEO 
        title="Galerie - Ali Baba Kebab & Vegie Sarnen | Fotos unserer Speisen"
        description="Impressionen aus unserem Restaurant in Sarnen. Sehen Sie unsere frisch zubereiteten Kebabs, Falafel und vegetarische Spezialitäten. Besuchen Sie uns!"
        keywords="Restaurant Fotos Sarnen, Kebab Bilder, Food Photography Sarnen"
        image="https://customer-assets.emergentagent.com/job_74889022-3a14-4f9f-9a7b-69c3c5635b4b/artifacts/bkldf31x_Alibaba%20Kebab%20Hero%20Photos.webp"
        path="/gallery"
      />
      
      {/* Hero */}
      <section className="section bg-[#1C1917] text-center">
        <div className="container mx-auto">
          <h1 className="text-6xl md:text-7xl text-white mb-6">GALERIE</h1>
          <p className="text-xl text-[#F7E39A] max-w-3xl mx-auto">
            Impressionen aus unserem Restaurant und von unseren Speisen
          </p>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="section bg-[#0F0E0D]">
        <div className="container mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {images.map((image, index) => (
              <div
                key={index}
                className="relative group overflow-hidden rounded-lg"
                style={{ border: '2px solid rgba(247, 227, 154, 0.3)' }}
              >
                <img
                  src={image.url}
                  alt={image.title}
                  className="w-full h-80 object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#1C1917] via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <span className="text-[#F7E39A] text-sm font-semibold">{image.category}</span>
                    <h3 className="text-white text-2xl font-bold mt-1">{image.title}</h3>
                    <p className="text-[#E3E3E3] text-sm mt-2">{image.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <p className="text-[#E3E3E3] text-lg mb-6">
              Folgen Sie uns auf Instagram für mehr Eindrücke und tägliche Updates!
            </p>
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary inline-block"
            >
              @alibaba_sarnen folgen
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Gallery;
